import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/http-client';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { ListadoUsuarios } from '../models/viewmodels/listadoUsuarios';
import { RolViewModel } from '../models/viewmodels/rolViewModel';
import { UsuarioViewModel, NuevoUsuarioViewModel, NuevoPasswordViewModel } from '../models/viewmodels/usuarioViewModel';

@Injectable()
export class UsuarioService {

    private usuarioActual: UsuarioViewModel;

    constructor(private httpClient: HttpClient) { }

    setUsuario(usuario: UsuarioViewModel) {
        this.usuarioActual = usuario;
    }

    getUsuario() {
        return this.usuarioActual;
    }

    listado(pagina: number, cantidadPorPagina: number, query: string): Observable<ListadoUsuarios> {
        // get users from api
        return this.httpClient.get(`/usuarios/?pagina=${pagina}&cantidadPorPagina=${cantidadPorPagina}&query=${query}`)
            .map(response => {
                return response.json();
            });
    }

    obtenerRoles(): Observable<RolViewModel[]> {
        return this.httpClient.get('/usuarios/roles')
            .map(response => {
                return response.json();
            });
    }    

    guardar(usuario: NuevoUsuarioViewModel) {
        return this.httpClient.post('/usuarios/', usuario);
    }

    modificar(usuario: UsuarioViewModel) {
        return this.httpClient.put('/usuarios/', usuario);
    }

    actualizarPassword(id: string, password:string) {
        return this.httpClient.post('/usuarios/resetPassword', {usuarioId: id, password: password});
    }

    eliminar(id: string) {
        return this.httpClient.delete(`/usuarios/${id}`);
    }

    recuperarContraseña(username:string){
        return this.httpClient.post('/usuarios/password/olvide', {username:username});
    }

    modificarPassword(usuario:NuevoPasswordViewModel) {
        return this.httpClient.post('/usuarios/password/nuevo', usuario);
    }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/usuario.service.ts